import styles from './loginPage.module.css'
import React, { useState, useEffect } from 'react';
import LoginForm from './LoginForm';
import { useNavigate, useLocation } from 'react-router-dom';
import { validateToken } from '../adminPanelTools';
function LoginPage() {

    const navigate = useNavigate();
    const handleLogin = (data) => {
        // redirect or show admin UI, etc.
    };

    const location = useLocation();
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (location.state && location.state.message) {
            setMessage(location.state.message);
        }
    }, [location.state]);

    useEffect(() => {
        const checkTokenAndRedirect = async () => {
            const isValid = await validateToken();
            if (isValid) {
                navigate("/admin/panel");
            }
        };

        checkTokenAndRedirect();
    }, [navigate]);

    return (
        <div className={styles.container}>
            {message && <p className={styles.message}>{message}</p>}
            <LoginForm onLogin={handleLogin} />

        </div>
    );
};

export default LoginPage;